/*
 * 快捷入口预览图 URL 解析。
 *
 * 每个模板一张 PNG,按 taskName 命名,已上传到 OSS(net-cloud.xhey.top/xhey-template-preview)。
 * 前端按 `${CHIP_PREVIEW_BASE}/${taskName}.png` 拼 URL,hover 快捷入口时右侧展示。
 * 换目录/域名只改 CHIP_PREVIEW_BASE 一处;某入口无 taskName(兜底入口)→ 返回 '' 走骨架占位。
 */
import { getChipTaskName } from './chipTaskName'

/** 预览图 OSS 基地址(结尾不带 /);按 `${CHIP_PREVIEW_BASE}/${taskName}.png` 取图。 */
export const CHIP_PREVIEW_BASE =
  'https://net-cloud.xhey.top/xhey-template-preview'

/** 入口名 → 预览图 URL;base 未配置或无 taskName → 返回 '',由面板走占位。 */
export function getChipPreviewUrl(label: string): string {
  const taskName = getChipTaskName(label)
  if (!CHIP_PREVIEW_BASE || !taskName) return ''
  return `${CHIP_PREVIEW_BASE}/${taskName}.png`
}
